import { render } from "./dietTreatment.vue?vue&type=template&id=5cbe76b9&scoped=true"
import script from "./dietTreatment.vue?vue&type=script&lang=js"
export * from "./dietTreatment.vue?vue&type=script&lang=js"

import "./dietTreatment.vue?vue&type=style&index=0&id=5cbe76b9&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbe76b9"]])

export default __exports__